type LocalStorageKeys = 'pwc-theme';
type LocalStorageParser<R> = (value: string | null) => R;

function getStorage(key: LocalStorageKeys): string | null;
function getStorage<R>(key: LocalStorageKeys, parser: LocalStorageParser<R>): R;
function getStorage<R>(
  key: LocalStorageKeys,
  parser?: LocalStorageParser<R>
): string | null | R {
  const value = localStorage.getItem(key);

  if (parser) {
    return parser(value);
  }

  return value;
}

const setStorage = (key: LocalStorageKeys, value: string): void => {
  return localStorage.setItem(key, value);
};

export default {
  get: getStorage,
  set: setStorage,
};
